// src/components/journal/WeekPresenceCard.jsx
import { getWeekDays } from '../../utils/presenca'
import { getHojeBR } from '../../utils/dataBR'

const DAY_LABELS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

export default function WeekPresenceCard({ logs, onNavigateToProfile }) {
  const weekDays = getWeekDays()
  const todayStr = getHojeBR()

  const logMap = {}
  logs.forEach(l => { logMap[l.date] = l })

  const completedCount = weekDays.filter(d => logMap[d]?.completed).length

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 8,
          background: 'var(--primary-light)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <rect x="1" y="2" width="14" height="13" rx="2" stroke="var(--navy)" strokeWidth="1.4"/>
            <path d="M5 1v2M11 1v2" stroke="var(--navy)" strokeWidth="1.4" strokeLinecap="round"/>
            <path d="M1 6h14" stroke="var(--navy)" strokeWidth="1.4"/>
          </svg>
        </div>
        <h2 className="section-title" style={{ margin: 0 }}>Sua Semana</h2>
      </div>

      {/* Day labels */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 5,
        marginBottom: 5,
      }}>
        {DAY_LABELS.map(d => (
          <div key={d} style={{
            textAlign: 'center',
            fontSize: 9,
            fontWeight: 600,
            color: 'var(--muted)',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            fontFamily: 'DM Sans, sans-serif',
          }}>
            {d}
          </div>
        ))}
      </div>

      {/* Day cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 5 }}>
        {weekDays.map(dateStr => {
          const isFuture = dateStr > todayStr
          const done = !!logMap[dateStr]?.completed

          return (
            <div
              key={dateStr}
              style={{
                paddingTop: '160%',
                position: 'relative',
                borderRadius: 8,
                background: done ? 'var(--lavender)' : 'transparent',
                border: `1.5px dashed ${done ? 'var(--lavender)' : 'rgba(47,43,95,0.22)'}`,
              }}
            >
              <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                {done ? (
                  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" aria-hidden="true">
                    <path d="M1.5 5.5L5.5 9.5L12.5 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <div style={{
                    width: 10, height: 10, borderRadius: '50%',
                    border: '1.5px solid rgba(47,43,95,0.18)',
                  }} />
                )}
              </div>
            </div>
          )
        })}
      </div>

      {/* Count + link */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 22 }}>
        <p style={{
          fontFamily: 'DM Sans, sans-serif',
          fontWeight: 700, fontSize: 15,
          color: 'var(--navy)', margin: 0,
        }}>
          {completedCount} de 7 dias concluídos
        </p>
        <button
          onClick={onNavigateToProfile}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 11, color: 'var(--lavender)', fontWeight: 500,
            fontFamily: 'DM Sans, sans-serif', padding: 0, flexShrink: 0,
          }}
        >
          ver histórico →
        </button>
      </div>
    </div>
  )
}
